/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * NoteIcon
 */
export default class NoteIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 1a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 013-3h13zM7 3H6a1 1 0 00-1 1v16a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1h-1v1a1 1 0 01-.883.993L17 5a1 1 0 01-.993-.883L16 4V3h-1v1a1 1 0 01-.883.993L14 5a1 1 0 01-.993-.883L13 4V3h-1v1a1 1 0 01-.883.993L11 5a1 1 0 01-.993-.883L10 4V3H9v1a1 1 0 01-.883.993L8 5a1 1 0 01-.993-.883L7 4V3zm5.5 13a1 1 0 010 2H9a1 1 0 010-2zM9 12h7a1 1 0 01.117 1.993L16 14H9a1 1 0 01-.117-1.993L9 12h7zm7-4a1 1 0 01.117 1.993L16 10H9a1 1 0 01-.117-1.993L9 8h7z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

